export default __webpack_public_path__ + "static/howto-5-464a1b49e1b53f027d39f9d17ef953f5.jpg";